
import { Component, Prop, Vue } from 'vue-property-decorator'
import { CDNVhostInterface } from '@/services/Vhost/CDN/Interfaces';

@Component
export default class RemoveServerDialog extends Vue {
  @Prop() private readonly server!: CDNVhostInterface
  @Prop() private readonly onDelete!: CallableFunction

  private visible: boolean = true

  get message(): string {
    return `Are you sure you want to remove vhost ${this.server.domain}?`
  }

  private destroyComponent(): void {
    this.$emit('close')
  }

  private async deleteServer(): Promise<void> {
    await this.onDelete(this.server)
    this.destroyComponent()
  }
}
